export default __webpack_public_path__ + "static/media/Radio_Active.adb4d901.svg";